import { axios } from "@/lib/axios";
import { ExtractFnReturnType, QueryConfig } from "@/lib/react-query";
import { AxiosError } from "axios";
import { useSnackbar } from "notistack";
import { useQuery } from "react-query";
import { Notification } from "../types/index";

export const getNotifications = async (): Promise<Notification[]> => {
  return await axios.get("/chatmessages/notifications");
};

type QueryFnType = typeof getNotifications;

type ExtractedFnReturnType = ExtractFnReturnType<QueryFnType>;

type UseLeadOptions<SelectedData> = {
  userId: number | string | undefined;
  config?: QueryConfig<QueryFnType, SelectedData>;
};

export const useNotifications = <SelectedData = ExtractedFnReturnType>({
  config,
  userId,
}: UseLeadOptions<SelectedData>) => {
  const { enqueueSnackbar } = useSnackbar();

  return useQuery<ExtractedFnReturnType, AxiosError, SelectedData>({
    ...config,
    queryKey: ["notifications", userId],
    queryFn: () => getNotifications(),
    enabled: !!userId,
    refetchInterval: 60000,
    onError: (error) => {
      const message = error.response?.data?.message || error.message;
      enqueueSnackbar(message, { variant: "error" });
    },
  });
};
